import { orientationChange } from '../utils/orientationChange';
import { onScroll, removeScroll, scrollTop } from '../utils/scroll';
import { enableScrollLock, disableScrollLock } from '../utils/scrollLock';
import { closeSearchBar } from './search';
import { isTouch } from '../utils/helpers';

export function setupNavigation() {
    const navigation = document.querySelector('.navigation');
    let logo;
    let primary;
    let primaryWithChildren;
    let level2WithChildren;
    const mdMq = window.matchMedia('(min-width: 1024px)');

    const scrollFunction = () => {
        if (scrollTop > 10) {
            navigation.classList.add('js-white');
        } else {
            navigation.classList.remove('js-white');
        }
    };

    function toggleMenuOpen() {
        if (document.body.classList.contains('js-nav-open')) {
            disableScrollLock();
            document.body.classList.remove('js-nav-open');

            if (window.pageYOffset > 50) {
                setTimeout(() => document.body.classList.add('going-up'), 40);
            }

            closeSearchBar();
        } else {
            enableScrollLock();
            document.body.classList.add('js-nav-open');
        }
    }

    function watchMegaMenu() {
        const megaMenus = document.querySelectorAll('.navigation__mega-menu');

        if (megaMenus.length > 0) {
            Array.from(megaMenus).forEach(menu => {
                menu.addEventListener('mouseenter', event => {
                    navigation.classList.add('js-megamenu-active');
                });

                menu.addEventListener('mouseleave', event => {
                    navigation.classList.remove('js-megamenu-active');
                });
            });
        }
    }

    function hideOpenMenus() {
        const activeLinks = Array.from(primaryWithChildren).filter(x => x.classList.contains('js-active'));
        const activeLevel2Links = Array.from(level2WithChildren).filter(x => x.closest('.navigation__sub-item').classList.contains('js-active'));

        activeLinks.forEach(activeLink => {
            activeLink.classList.remove('js-active');

            const activeElement = activeLink.closest('.navigation__item');

            if (activeElement) {
                activeElement.classList.remove('js-open');
            }
        });

        activeLevel2Links.forEach(activeLink => {
            activeLink.closest('.navigation__sub-item').classList.remove('js-active');
        });

        if (isTouch) {
            removeBodyEvents();
        }
    }

    function updateMenu(e) {
        if (!e.target.closest('.navigation')) {
            hideOpenMenus();
        }
    }

    function addBodyEvents() {
        document.body.addEventListener('click',updateMenu);
    }

    function removeBodyEvents() {
        document.body.addEventListener('click',updateMenu);
    }

    function toggleLevel1Open(item,level2) {
        if (item.classList.contains('js-open')) {
            item.classList.remove('js-open');
            level2.style.height = null;

            if (isTouch) {
                removeBodyEvents();
            }
        } else {
            item.classList.add('js-open');

            if (!mdMq.matches) {
                level2.style.height = `${level2.scrollHeight}px`;
            }

            if (isTouch) {
                addBodyEvents();
            }
        }
    }

    function clickLinkWithChildren(e) {
        const link = e.currentTarget;

        if (!link.classList.contains('js-active')) {
            e.preventDefault();
        }

        const item = e.target.closest('.level-1.navigation__item');

        if (item && link) {
            if (isTouch) {
                hideOpenMenus();
            }

            if (link.classList.contains('js-active')) {
                link.classList.remove('js-active');
            } else {
                link.classList.add('js-active');
            }

            const level2 = item.querySelector('.navigation__sub');

            if (level2) {
                toggleLevel1Open(item,level2);
            }
        }
    }

    function addLinkEvents() {
        Array.from(primaryWithChildren).forEach(link => {
            link.addEventListener('click',clickLinkWithChildren);
        });
    }

    function removeLinkEvents() {
        Array.from(primaryWithChildren).forEach(link => {
            link.removeEventListener('click', clickLinkWithChildren);
        });
    }

    function watchSamePageLinks() {
        const path = window.location.pathname;
        const subLinks = document.querySelectorAll('.navigation__sub-link[href*="#module"]');

        subLinks.forEach(subLink => {
            const subLinkPath = subLink.href.substring(subLink.href.lastIndexOf('/'),subLink.href.indexOf('#'));

            if (path == subLinkPath) {
                subLink.addEventListener('click',toggleMenuOpen);
            }
        });
    }

    function clickL2LinkWithChildren(e) {
        const item = e.currentTarget.closest('.navigation__sub-item--has-children');

        if (!item.classList.contains('js-active') && mdMq.matches) {
            e.preventDefault();
            item.classList.add('js-active');
        }
    }

    if (navigation) {
        logo = navigation.querySelector('.navigation__logo');
        primary = navigation.querySelector('.navigation__primary');
        const navigationButton = navigation.querySelector('.navigation__burger');

        if (logo && primary) {
            primaryWithChildren = document.querySelectorAll('.level-1.navigation__item--has-children > a');

            orientationChange(() => {
                if (mdMq.matches && !isTouch) {
                    onScroll(scrollFunction);
                    removeLinkEvents();
                } else {
                    removeScroll(scrollFunction);
                    addLinkEvents();
                }
            }, true);

            watchMegaMenu();
            watchSamePageLinks();
        }

        if (navigationButton) {
            navigationButton.addEventListener('click', toggleMenuOpen);
        }

        if (isTouch) {
            level2WithChildren = document.querySelectorAll('.navigation__sub-item--has-children > a');

            level2WithChildren.forEach(link => {
                link.addEventListener('click',clickL2LinkWithChildren);
            });
        }
    }
}
